var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "70%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "70%" } },
        [
          _c(
            "v-card-actions",
            [
              _c("v-card-text", { staticClass: "ma-0 pa-0 green--text" }, [
                _vm._v(_vm._s(this.user == null ? "" : this.user.email)),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-card",
                {
                  staticStyle: { "overflow-y": "scroll" },
                  attrs: {
                    width: "100%",
                    outlined: "",
                    elevation: "0",
                    height: "500px",
                  },
                },
                [
                  _vm._l(_vm.appPermisions, function (item) {
                    return [
                      _c(
                        "v-list-item",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "ma-0 pa-1" },
                            [
                              _c(
                                "v-card",
                                { attrs: { elevation: "0", outlined: "" } },
                                [
                                  _c(
                                    "v-card-actions",
                                    { staticClass: "ma-0 pa-0 mx-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "blue--text",
                                          staticStyle: { "font-size": "0.9em" },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "grey--text",
                                          staticStyle: {
                                            "margin-left": "10px",
                                            "font-size": "0.8em",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.message))]
                                      ),
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onPressCheckbox(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm.isActivePermission(item)
                                            ? _c(
                                                "v-icon",
                                                { attrs: { color: "blue" } },
                                                [_vm._v("mdi-checkbox-marked")]
                                              )
                                            : _c(
                                                "v-icon",
                                                { attrs: { color: "blue" } },
                                                [
                                                  _vm._v(
                                                    "mdi-checkbox-blank-outline"
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(item.subpermissions, function (sitem) {
                                    return [
                                      _c(
                                        "v-card-actions",
                                        { staticClass: "ma-0 pa-0 mx-1" },
                                        [
                                          _c("v-hover", {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ hover }) {
                                                    return [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-0 mb-1",
                                                          attrs: {
                                                            width: "100%",
                                                            elevation: 0,
                                                            color: hover
                                                              ? "grey lighten-4"
                                                              : "grey lighten-5",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-actions",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0 mx-2",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "-5px",
                                                                  },
                                                                  attrs: {
                                                                    size: "15",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-arrow-right-bottom"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "blue-grey--text",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "10px",
                                                                    "font-size":
                                                                      "0.9em",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      sitem.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "grey--text",
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "10px",
                                                                    "font-size":
                                                                      "0.8em",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      sitem.message
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("v-spacer"),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.onPressCheckbox(
                                                                          sitem
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm.isActivePermission(
                                                                    sitem
                                                                  )
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "blue",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-checkbox-marked"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "blue",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-checkbox-blank-outline"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.settingPermissions, color: "primary" },
                  on: { click: _vm.onPressUse },
                },
                [_vm._v("Apply ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }